import React from 'react';

const Icon16OrientationLeft = React.lazy(() =>
  import('components/icons/icon16OrientationLeft')
);
const Icon16OrientationRight = React.lazy(() =>
  import('components/icons/icon16OrientationRight')
);
const Icon16Orientation1ReclinerLeft = React.lazy(() =>
  import('components/icons/icon16Orientation1ReclinerLeft')
);
const Icon16Orientation1ReclinerRight = React.lazy(() =>
  import('components/icons/icon16Orientation1ReclinerRight')
);
const Icon16Orientation2ReclinerLeft = React.lazy(() =>
  import('components/icons/icon16Orientation2ReclinerLeft')
);
const Icon16Orientation2ReclinerRight = React.lazy(() =>
  import('components/icons/icon16Orientation2ReclinerRight')
);

const Icon70OrientationL2ReclinerL = React.lazy(() =>
  import('components/icons/icon70OrientationL2ReclinerL')
);

const Icon74ChaiseOrientationLeft = React.lazy(() =>
  import('components/icons/icon74ChaiseOrientationLeft')
);
const Icon74ChaiseOrientationRight = React.lazy(() =>
  import('components/icons/icon74ChaiseOrientationRight')
);

const Icon85OrientationBumperChaiseLeft = React.lazy(() =>
  import('components/icons/icon85OrientationBumperChaiseLeft')
);
const Icon85OrientationBumperChaiseRight = React.lazy(() =>
  import('components/icons/icon85OrientationBumperChaiseRight')
);

const Icon89154SingleArmChaiseLeft = React.lazy(() =>
  import('components/icons/icon89154SingleArmChaiseLeft')
);
const Icon89154SingleArmChaiseRight = React.lazy(() =>
  import('components/icons/icon89154SingleArmChaiseRight')
);

const Icon117OrientationSleeperLeft = React.lazy(() =>
  import('components/icons/icon117OrientationSleeperLeft')
);
const Icon117OrientationSleeperRight = React.lazy(() =>
  import('components/icons/icon117OrientationSleeperRight')
);

const Icon119OrientationSingleArmSofaLeft = React.lazy(() =>
  import('components/icons/icon119OrientationSingleArmSofaLeft')
);
const Icon119OrientationSingleArmSofaRight = React.lazy(() =>
  import('components/icons/icon119OrientationSingleArmSofaRight')
);

const Icon123OrientationUSofaBumperSectionalLeft = React.lazy(() =>
  import('components/icons/icon123OrientationUSofaBumperSectionalLeft')
);
const Icon123OrientationUSofaBumperSectionalRight = React.lazy(() =>
  import('components/icons/icon123OrientationUSofaBumperSectionalRight')
);

const Icon153OrientationDisplaySingleArmChairLeft = React.lazy(() =>
  import('components/icons/icon153OrientationDisplaySingleArmChairLeft')
);
const Icon153OrientationDisplaySingleArmChairRight = React.lazy(() =>
  import('components/icons/icon153OrientationDisplaySingleArmChairRight')
);
const Icon153OrientationDisplaySingleArmChairRecliningLeft = React.lazy(() =>
  import(
    'components/icons/icon153OrientationDisplaySingleArmChairRecliningLeft'
  )
);
const Icon153OrientationDisplaySingleArmChairRecliningRight = React.lazy(() =>
  import(
    'components/icons/icon153OrientationDisplaySingleArmChairRecliningRight'
  )
);

const Icon170OrientationConfiguration2Recliner = React.lazy(() =>
  import('components/icons/icon170OrientationConfiguration2Recliner')
);
const Icon170OrientationConfiguration3Recliner = React.lazy(() =>
  import('components/icons/icon170OrientationConfiguration3Recliner')
);
const Icon170OrientationConfiguration2ReclinerCorner = React.lazy(() =>
  import('components/icons/icon170OrientationConfiguration2ReclinerCorner')
);
const Icon170OrientationConfiguration3ReclinerCorner = React.lazy(() =>
  import('components/icons/icon170OrientationConfiguration3ReclinerCorner')
);

const Icon171OrientationReclining = React.lazy(() =>
  import('components/icons/icon171OrientationReclining')
);
const Icon171OrientationNonReclining = React.lazy(() =>
  import('components/icons/icon171OrientationNonReclining')
);

const getOrientationOptionIconV2 = (optionId, optionSku) => {
  const normalizedSku = (optionSku || '').toUpperCase();
  let customItem = null;
  const fkOptionId = parseInt(optionId, 10);

  switch (fkOptionId) {
    case 16:
      if (normalizedSku === '-LAF') customItem = <Icon16OrientationLeft />;
      else if (normalizedSku === '-RAF')
        customItem = <Icon16OrientationRight />;
      else if (normalizedSku === '-2RCLNRLAF')
        customItem = <Icon16Orientation2ReclinerLeft />;
      else if (normalizedSku === '-2RCLNRRAF')
        customItem = <Icon16Orientation2ReclinerRight />;
      else if (normalizedSku === '-1RCLNRLAF')
        customItem = <Icon16Orientation1ReclinerLeft />;
      else if (normalizedSku === '-1RCLNRRAF')
        customItem = <Icon16Orientation1ReclinerRight />;
      break;

    case 70:
      if (normalizedSku === '-2LSCTNL')
        customItem = <Icon70OrientationL2ReclinerL />;
      else if (normalizedSku === '-LAF') customItem = <Icon16OrientationLeft />;
      // Fallback
      else if (normalizedSku === '-RAF')
        customItem = <Icon16OrientationRight />; // Fallback
      break;

    case 74:
      if (normalizedSku === '-LAF')
        customItem = <Icon74ChaiseOrientationLeft />;
      else if (normalizedSku === '-RAF')
        customItem = <Icon74ChaiseOrientationRight />;
      break;

    case 85:
      if (normalizedSku === '-LAF')
        customItem = <Icon85OrientationBumperChaiseLeft />;
      else if (normalizedSku === '-RAF')
        customItem = <Icon85OrientationBumperChaiseRight />;
      break;

    case 89:
      if (normalizedSku === '-SACAFL')
        customItem = <Icon89154SingleArmChaiseLeft />;
      else if (normalizedSku === '-SACAFR')
        customItem = <Icon89154SingleArmChaiseRight />;
      break;

    case 117:
      if (normalizedSku === '-LS')
        customItem = <Icon117OrientationSleeperLeft />;
      else if (normalizedSku === '-RS')
        customItem = <Icon117OrientationSleeperRight />;
      break;

    case 119:
      if (normalizedSku === '-LAF')
        customItem = <Icon119OrientationSingleArmSofaLeft />;
      else if (normalizedSku === '-RAF')
        customItem = <Icon119OrientationSingleArmSofaRight />;
      break;

    // ref: https://stitchindustries.atlassian.net/browse/CON-8148?focusedCommentId=138159
    case 120:
      if (normalizedSku === '-LFB') customItem = <Icon16OrientationLeft />;
      else if (normalizedSku === '-RFB')
        customItem = <Icon16OrientationRight />;
      break;

    case 123:
      if (normalizedSku === '-LFB')
        customItem = <Icon123OrientationUSofaBumperSectionalLeft />;
      else if (normalizedSku === '-RFB')
        customItem = <Icon123OrientationUSofaBumperSectionalRight />;
      break;

    case 153:
      if (normalizedSku === '-SCHL')
        customItem = <Icon153OrientationDisplaySingleArmChairLeft />;
      else if (normalizedSku === '-SCHR')
        customItem = <Icon153OrientationDisplaySingleArmChairRight />;
      else if (normalizedSku === '-RCLNGSLFT')
        customItem = <Icon153OrientationDisplaySingleArmChairRecliningLeft />;
      else if (normalizedSku === '-RCLNGSRT')
        customItem = <Icon153OrientationDisplaySingleArmChairRecliningRight />;
      else if (normalizedSku === '-NRCLNSLFT')
        customItem = <Icon153OrientationDisplaySingleArmChairLeft />;
      else if (normalizedSku === '-NRCLNSRT')
        customItem = <Icon153OrientationDisplaySingleArmChairRight />;
      break;

    case 154:
      if (normalizedSku === '-SCHSL')
        customItem = <Icon89154SingleArmChaiseLeft />;
      else if (normalizedSku === '-SCHSR')
        customItem = <Icon89154SingleArmChaiseRight />;
      break;

    case 170:
      if (normalizedSku === '-2RECLINER')
        customItem = <Icon170OrientationConfiguration2Recliner />;
      else if (normalizedSku === '-3RECLINER')
        customItem = <Icon170OrientationConfiguration3Recliner />;
      else if (normalizedSku === '-2CRNRRCLNR')
        customItem = <Icon170OrientationConfiguration2ReclinerCorner />;
      else if (normalizedSku === '-3CRNRRCLNR')
        customItem = <Icon170OrientationConfiguration3ReclinerCorner />;
      else if (normalizedSku === '-1RECLINERLAF')
        customItem = <Icon16Orientation1ReclinerLeft />;
      else if (normalizedSku === '-1RECLINERRAF')
        customItem = <Icon16Orientation1ReclinerRight />;
      else if (normalizedSku === '-2RECLINERLAF')
        customItem = <Icon16Orientation2ReclinerLeft />;
      else if (normalizedSku === '-2RECLINERRAF')
        customItem = <Icon16Orientation2ReclinerRight />;
      break;

    case 171:
      if (normalizedSku === '-RCLNNG')
        customItem = <Icon171OrientationReclining />;
      else if (normalizedSku === '-NNRCLNNG')
        customItem = <Icon171OrientationNonReclining />;
      break;

    default:
      break;
  }

  // Universal Fallbacks
  if (!customItem) {
    if (
      normalizedSku === '-LAF' ||
      normalizedSku === '-SACAFL' ||
      normalizedSku === '-SCHL' ||
      normalizedSku === '-SCHSL' ||
      normalizedSku === '-LS' ||
      normalizedSku === '-LFB'
    ) {
      // Use the generic 89-154 fallback for unknown lefts if they fall in range
      if (fkOptionId >= 89 && fkOptionId <= 154)
        customItem = <Icon89154SingleArmChaiseLeft />;
      else customItem = <Icon16OrientationLeft />;
    } else if (
      normalizedSku === '-RAF' ||
      normalizedSku === '-SACAFR' ||
      normalizedSku === '-SCHR' ||
      normalizedSku === '-SCHSR' ||
      normalizedSku === '-RS' ||
      normalizedSku === '-RFB'
    ) {
      // Use the generic 89-154 fallback for unknown rights if they fall in range
      if (fkOptionId >= 89 && fkOptionId <= 154)
        customItem = <Icon89154SingleArmChaiseRight />;
      else customItem = <Icon16OrientationRight />;
    }
  }

  return { image: undefined, customItem };
};

export default getOrientationOptionIconV2;
